import { connect } from "react-redux";
import { reduxForm, SubmissionError } from "redux-form";

import * as actions from "../constants/actions";
import CreateModelForm from "../components/forms/CreateModelForm";

const onSubmit = (values, dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(actions.createModel({ values, resolve, reject }));
  }).catch(error => {
    throw new SubmissionError({ _error: error });
  });
};

const form = reduxForm({
  form: "createUserModelForm",
  onSubmit
})(CreateModelForm);

const mapStateToProps = state => ({
  folders: state.folders
});

const mapDispatchToProps = dispatch => ({
  openModal: payload => dispatch(actions.openModal(payload)),
  closeModal: () => dispatch(actions.closeModal())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(form);



// WEBPACK FOOTER //
// ./src/containers/CreateModelForm.js